import { useContext } from "react";
import { AppContext } from "@/App";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const STRINGS = {
  it: {
    label: "Domande frequenti",
    title: "Tutto chiaro, prima di salire",
    items: [
      {
        q: "Il prezzo è davvero fisso?",
        a: "Sì. Il preventivo che vedi include tasse, pedaggi e attesa standard. Nessun prezzo dinamico, nessuna sorpresa: quello che vedi è quello che paghi.",
      },
      {
        q: "Cosa succede se il mio volo ritarda?",
        a: "Monitoriamo il volo in tempo reale e adattiamo l'orario di ritiro automaticamente. In aeroporto sono inclusi 60 minuti di attesa gratuita dall'atterraggio.",
      },
      {
        q: "Posso cancellare o modificare la prenotazione?",
        a: "Sì, gratuitamente fino a 1 ora prima del ritiro. Ti basta scriverci su WhatsApp o chiamare il +39 348 221 5105.",
      },
      {
        q: "Come posso pagare?",
        a: "Online in totale sicurezza con carte, Apple Pay o Google Pay, oppure a bordo direttamente al chauffeur, in contanti o con carta.",
      },
      {
        q: "Quanti bagagli posso portare? E i seggiolini?",
        a: "Classe E e S: fino a 3 valigie. Classe V: fino a 8 valigie e 7 passeggeri. Seggiolini e rialzi per bambini disponibili gratuitamente su richiesta.",
      },
    ],
  },
  en: {
    label: "Frequently asked questions",
    title: "Everything clear, before you board",
    items: [
      {
        q: "Is the price really fixed?",
        a: "Yes. The quote you see includes taxes, tolls and standard waiting time. No surge pricing, no surprises: what you see is what you pay.",
      },
      {
        q: "What happens if my flight is delayed?",
        a: "We track your flight in real time and adjust the pickup time automatically. Airport pickups include 60 minutes of free waiting after landing.",
      },
      {
        q: "Can I cancel or change my booking?",
        a: "Yes, free of charge up to 1 hour before pickup. Just message us on WhatsApp or call +39 348 221 5105.",
      },
      {
        q: "How can I pay?",
        a: "Securely online with cards, Apple Pay or Google Pay, or on board directly to your chauffeur, in cash or by card.",
      },
      {
        q: "How much luggage can I bring? And child seats?",
        a: "E-Class and S-Class: up to 3 suitcases. V-Class: up to 8 suitcases and 7 passengers. Child seats and boosters available free on request.",
      },
    ],
  },
};

export default function Faq() {
  const { lang } = useContext(AppContext);
  const s = STRINGS[lang];
  return (
    <section data-testid="faq-section" className="mx-auto max-w-3xl px-4 pb-24 sm:px-6">
      <p className="label-accent">{s.label}</p>
      <h2 className="font-display mt-3 text-3xl font-medium text-amber-100/90 sm:text-4xl">{s.title}</h2>
      <Accordion type="single" collapsible className="mt-10">
        {s.items.map((item, i) => (
          <AccordionItem
            key={i}
            value={`faq-${i}`}
            data-testid={`faq-item-${i}`}
            className="border-[rgba(212,175,55,0.15)]"
          >
            <AccordionTrigger className="font-display text-left text-lg font-medium text-white hover:text-[#E5C158] hover:no-underline">
              {item.q}
            </AccordionTrigger>
            <AccordionContent className="text-sm leading-relaxed text-neutral-400">
              {item.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </section>
  );
}
